const UPLOAD_SPREADSHEET = 'upload_spreadsheet';
const REVIEW_IMPORT = 'review_import';

const UPLOAD_EMAIL_STEPS = {
  UPLOAD_SPREADSHEET: UPLOAD_SPREADSHEET,
  REVIEW_IMPORT: REVIEW_IMPORT
};
export { UPLOAD_EMAIL_STEPS };
